module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n	<div class="text-block">\n		<h5>Unfortunately this page isn\'t available on mobile devices.</h5>\n		<p>Please download the NRL Fantasy app, or head to the NRL Fantasy website on a desktop computer.</p>\n	</div>\n</div>';
}
return __p;
};
